import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './index.module.less';
import { FAQ_ITEMS } from '../../constants';


/** FAQ：设计稿 #10899:3864 */
const Faq: React.FC<{ isModal?: boolean }> = ({ isModal = false }) => {
  const { t } = useTranslation('common');
  const SectionHeading = isModal ? 'h3' : 'h2';
  const QuestionHeading = isModal ? 'h4' : 'h3';

  // 设计稿默认展开第一条
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const idPrefix = isModal ? 'affiliate-modal-faq' : 'affiliate-faq';

  return (
    <section className={styles.container}>
      <div className={styles.inner}>
        <SectionHeading className={styles.title}>{t('FrequentlyAskedQuestions')}</SectionHeading>

        <div className={styles.list}>
          {FAQ_ITEMS.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className={styles.item}>
                <QuestionHeading className={styles.questionHeading}>
                  <button
                    type="button"
                    className={styles.question}
                    aria-expanded={isOpen}
                    aria-controls={`${idPrefix}-panel-${index}`}
                    id={`${idPrefix}-trigger-${index}`}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                  >
                    <span className={styles.questionText}>{t(item.q)}</span>
                    {/* #10899:3868，资源本身朝上，收起态旋转 180° */}
                    <svg
                      className={`${styles.chevron} ${isOpen ? '' : styles.chevronDown}`}
                      width="12"
                      height="6"
                      viewBox="0 0 12 6"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M11 5L6 1L1 5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </QuestionHeading>
                <div
                  className={styles.panel}
                  id={`${idPrefix}-panel-${index}`}
                  role="region"
                  aria-labelledby={`${idPrefix}-trigger-${index}`}
                  hidden={!isOpen}
                >
                  <p className={styles.answer}>{t(item.a)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
